import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchStateType, SelectPassengerType } from "../../../Orchestrator/Types/Index";
import { getMaxAllowedInfants, isChildIncrementDisabled } from "../../../Lib/Utils/passengerValidation";

export class PassengerSelectionAction extends BaseAction<Partial<SearchStateType>, SelectPassengerType> {

    override async run(): Promise<Partial<SearchStateType> | null> {
        const { type, value, search, isFromPopUp, searchPopupData } = this.params!;
        const isInfant = type === "infants";
        const isChild = type === "children";
        const currentCount = search.passengers?.[type] || 0;
        const newCount = currentCount + value;
        const passengers = search.passengers || {};

        // ONE_ADULT_OR_SENIOR_PER_INFANT: only allow increment when new count ≤ adults + seniors
        if (isInfant && value > 0) {
            const maxAllowed = getMaxAllowedInfants(passengers);
            if (newCount > maxAllowed) {
                console.warn("[PassengerSelectionAction] Infant increment blocked — exceeds adult+senior count", { newCount, maxAllowed, passengers });
                return null;
            }
        }

        // ONE_ADULT_OR_SENIOR: children require at least 1 adult or senior citizen
        if (isChild && value > 0 && isChildIncrementDisabled(passengers)) {
            console.warn("[PassengerSelectionAction] Child increment blocked — no adults or seniors present", { passengers });
            return null;
        }

        if (isFromPopUp) {
            const oldSearchPopupData = { ...searchPopupData };
            if (!oldSearchPopupData.oldSearch) {
                oldSearchPopupData.oldSearch = { ...search };
                updateRecoilState("searchStatePopupAtom", oldSearchPopupData);
            }
        }

        const modifiedData = (prev: SearchStateType) => ({
            ...prev,
            passengers: {
              ...(prev.passengers ?? {}),
              [type]: Math.max(0, newCount),
            },
        });
        updateRecoilState("searchStateAtom", modifiedData);
        // Result is computed from the captured search snapshot for context display only;
        // the atom update uses the functional form (prev => ...) to avoid stale reads.
        return modifiedData(search);
    }
}